import * as Colors from '@ant-design/colors';
import { Select, Tag, Tooltip } from 'antd';
import styled from 'styled-components';
import moment from 'moment';

import { txt } from '../../locales/i18n';
import { formatDate } from '../../utils/date';

type Subscription = { state: string; plan_handle: string; created: Date, firstPeriodStart: Date };

export const subscriptions: any = {
	pending: { text: Colors.blue.primary, background: Colors.blue[0] },
	active: { text: Colors.green.primary, background: '#e5ffcc' },
	dunning_renewal: { text: Colors.orange.primary, background: Colors.orange[0] },
	expired_dunning_renewal: { text: Colors.red.primary, background: Colors.red[0] },
	cancelled: { text: Colors.grey.primary, background: '#eee' },
	expired: { text: Colors.red.primary, background: Colors.red[0] },
	expired_dunning: { text: 'blueviolet', background: 'lavender' },
};

export const SubscriptionTags = () => (
	<StyledSubscriptionTags>
		{Object.entries(subscriptions).map(([subscription, colors]: any[]) => (
			<Tooltip title={txt('subscriptions.' + subscription + ' description')}>
				<Tag key={subscription} color={colors.background}>
					<span style={{ color: colors.text }}>
						{txt('subscriptions.' + subscription)}
					</span>
				</Tag>
			</Tooltip>
		))}
	</ StyledSubscriptionTags>
);

const StyledSubscriptionTags = styled.div`
	display: flex;
	justify-content: center;
	gap: 2ch;
	flex-wrap: wrap;
	margin-block: 1ch;
`;

export const SubscriptionSelector = (
	<Select placeholder={txt('global.subscription')} dropdownMatchSelectWidth={false} allowClear>
		<Select.Option value="all">{txt('global.all')}</Select.Option>

		{Object.keys(subscriptions).map((subscription) => (
			<Select.Option key={subscription} value={subscription}>
				{txt('subscriptions.' + subscription)}
			</Select.Option>
		))}
	</Select>
);

export const renderHeaderSubscription = (subscription: Subscription, isMobileDevice: boolean) => {
	const colors = subscriptions[subscription.state] ?? null;
	if (colors === null) return null;

	const tooltip = (
		<>
			<span>{txt('subscriptions.' + subscription.state)}</span>{' '}
			<span>{subscription.plan_handle}</span>
			<br />
			<span>{moment(subscription.created).format('ll')}</span>
		</>
	);

	return (
		<StyledSubscription color={colors.text} background={colors.background}>
			<Tooltip title={tooltip}>
				<span>
					{txt(isMobileDevice ? 'global.subscription short' : 'global.subscription')}
				</span>
			</Tooltip>
		</StyledSubscription>
	);
};

const StyledSubscription = styled.div<{ color: string; background: string }>`
	margin-left: auto;
	display: flex;
	align-items: center;
	justify-content: center;

	span {
		padding: 1ch 2ch;
		border-radius: 1ch;
		color: ${({ color }) => color};
		background-color: ${({ background }) => background};
	}
`;

export const renderSubscription = (subscription: Subscription | null = null) => {
	if (subscription === null) return null;
	const colors = subscriptions[subscription.state];

	return (
		<Tooltip title={txt(`subscriptions.${subscription.state}`)}>
			<Tag color={colors.background}>
				<span style={{ color: colors.text }}>{formatDate(subscription.firstPeriodStart ?? subscription.created)}</span>
			</Tag>
		</Tooltip>
	);
};
